import { BordOneToneIcon } from 'components/NudosComponents';
import { QUOTE_TYPE } from 'types/bulkUpload';

import './QuoteTypeSelector.scss';

interface QuoteTypeSelectorProps {
  selectedQuoteType: QUOTE_TYPE;
  onSelectQuoteType: (quoteType: QUOTE_TYPE) => void;
}

const QuoteTypeSelector = ({ selectedQuoteType, onSelectQuoteType }: QuoteTypeSelectorProps) => {
  const regularQuoteFeatures = [
    'Pueden cargar para varios clientes en un mismo archivo',
    'Es obligatorio el ID del cliente y debe existir en Soga',
    'El país debe existir en Soga',
    'Es obligatorio la descripción del item y la cantidad',
    'Es visible en Dash para el cliente'
  ];

  const exploratoryQuoteFeatures = [
    'Un archivo por cliente',
    'No es obligatorio agregar el ID del cliente',
    'Puede ser para cualquier país',
    'Es obligatorio la descripción del item y la cantidad',
    'Es solo para gestión interna'
  ];

  const handleCardClick = (quoteType: QUOTE_TYPE) => {
    onSelectQuoteType(quoteType);
  };

  return (
    <div className="quoteTypeSelector">
      <p className="quoteTypeSelectorTitle">Antes de cargar la cotización, ten en cuenta lo siguiente:</p>
      <div className="quoteTypeSelectorCards">
        <div
          className={`quoteTypeSelectorCard ${
            selectedQuoteType === QUOTE_TYPE.REGULAR ? 'quoteTypeSelectorCardSelected' : ''
          }`}
          onClick={() => handleCardClick(QUOTE_TYPE.REGULAR)}
        >
          <div className="quoteTypeSelectorCardInfo">
            <div className="quoteTypeSelectorCardHeader">
              <div className="quoteTypeSelectorCardTitleContainer">
                <BordOneToneIcon variant="shield" customWidth="12px" className="iconTypeSelector" />
                <h3 className="quoteTypeSelectorCardTitle">Cotización regular</h3>
              </div>
              <span className="quoteTypeSelectorCardBadge">Con validaciones</span>
            </div>
            <ul className="quoteTypeSelectorCardFeatures">
              {regularQuoteFeatures.map((feature, index) => (
                <li key={`regular-list-${index}`} className="quoteTypeSelectorCardFeature">
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="quoteTypeSelectorCardFooter">
            <p>
              Será visible en Dash para revisión del cliente y finalización de la compra. Entre más detallada esté la
              información se garantizará una mejor cotización.
            </p>
          </div>
        </div>
        <div
          className={`quoteTypeSelectorCard ${
            selectedQuoteType === QUOTE_TYPE.EXPLORATORY ? 'quoteTypeSelectorCardSelected' : ''
          }`}
          onClick={() => handleCardClick(QUOTE_TYPE.EXPLORATORY)}
        >
          <div className="quoteTypeSelectorCardInfo">
            <div className="quoteTypeSelectorCardHeader">
              <div className="quoteTypeSelectorCardTitleContainer">
                <BordOneToneIcon variant="info" customWidth="12px" className="iconTypeSelector" />
                <h3 className="quoteTypeSelectorCardTitle">Cotización exploratoria</h3>
              </div>
              <span className="quoteTypeSelectorCardBadge">Uso interno</span>
            </div>
            <ul className="quoteTypeSelectorCardFeatures">
              {exploratoryQuoteFeatures.map((feature, index) => (
                <li key={`exploratory-list-${index}`} className="quoteTypeSelectorCardFeature">
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="quoteTypeSelectorCardFooter">
            <p>
              Se gestionará por medio de un Excel desde Soga. Entre más detallada esté la información se garantizará una
              mejor cotización.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteTypeSelector;
